<div class="cellStyle statusCell">
    <div class="statusCircle" [style.background-color]="color"></div>
    <div class="clip-overflow">{{ text }}</div>
    <ng-container *ngIf="isDialer">
        <svg class="icon-16 dialer-icon">
            <use href="../../App_Themes/CXone/icons/outbound-dialer.svg#outbound-dialer"></use>
        </svg>
    </ng-container>
</div>
